var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferralScheme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 254.5 200",
    style: {
      enableBackground: "new 0 0 254.5 200"
    },
    xmlSpace: "preserve",
    width: "3rem",
    height: "3rem",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0 { fill: #333d45; }\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100,145.4c-8.7,0-17-0.9-25-2.3c-11.8,8.4-25.1,14.5-39.5,18.2c-3.8,1-8,1.7-12.2,2.3c-0.1,0-0.3,0-0.4,0 c-2.1,0-4.1-1.7-4.5-4.1l0,0c-0.6-2.7,1.3-4.4,2.8-6.2c5.5-6.2,11.8-11.8,16.6-23.6C14.8,116.3,0,95.7,0,72.7C0,32.5,44.7,0,100,0 s100,32.5,100,72.7S155.2,145.4,100,145.4z M216.7,166c4.8,11.8,11.1,17.3,16.6,23.6c1.6,1.8,3.4,3.6,2.8,6.2l0,0 c-0.6,2.6-2.7,4.4-5,4.1c-4.3-0.6-8.4-1.3-12.2-2.3c-14.3-3.7-27.7-9.8-39.5-18.2c-8,1.4-16.3,2.3-25,2.3c-25.7,0-49.3-7.1-67-18.7 c4.1,0.3,8.4,0.6,12.5,0.6c30.5,0,59.4-8.8,81.4-24.7c23.7-17.3,36.8-40.8,36.8-66.2c0-7.4-1.1-14.6-3.3-21.6 c24,13.2,39.6,34.2,39.6,57.9C254.5,132.2,239.7,152.7,216.7,166z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralScheme);
export default __webpack_public_path__ + "static/media/Referral_scheme.fc78c834ac7ded06445f722b42ef0c96.svg";
export { ForwardRef as ReactComponent };